import React from 'react';

class LazyLoading extends React.Component {
  static defaultProps = {
    threshold: 100,
    height: 200,
  };

  constructor(props) {
    super(props);
    this.onScroll = this.onScroll.bind(this);
  }

  onScroll(e) {
    const { onThresholdExceed, height, threshold } = this.props;
    const { scrollHeight, scrollTop } = e.target;

    if (scrollHeight - (scrollTop + height) < threshold) {
      onThresholdExceed();
    }
  }

  render() {
    // @ts-ignore TS(2339): Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
    const { children, height } = this.props;
    return (
      <div
        style={{ height, overflowY: 'auto' }}
        className="ws-lazy-loading"
        onScroll={this.onScroll}
      >
        {children}
      </div>
    );
  }
}

export default LazyLoading;
